// This is useful so you don't have to make changes in several places when the provider
// changes their JS URL instructions on you
export const stampedJsUrl = () => "//cdn1.stamped.io/files/widget.min.js"

// Use this to determine if you need to lazyload the external JS script
export const checkStampedLoaded = () => typeof StampedFn !== "undefined"

// Finally, this is the reload mechanism that you want to use within the ref
// This returns a timeoutID. Be sure to clear it on unmount.
export const reloadStamped = ({ gallery = false } = {}) => {
  if (checkStampedLoaded()) {
    // Never trust external code, so a try-catch will be useful here to avoid React crashes
    try {
      // eslint-disable-next-line no-undef
      StampedFn.init({
        apiKey: gallery
          ? sl.api.stamped.gallery_public_key
          : sl.api.stamped.public_key,
        sId: gallery
          ? sl.api.stamped.gallery_store_hash
          : sl.api.stamped.store_hash,
      })

      return setTimeout(
        () =>
          // eslint-disable-next-line no-undef
          StampedFn.reloadUGC(),
        500
      )
    } catch (e) {
      console.log("Stamped threw error", e)
    }
  }
}
